import PropTypes from 'prop-types';
import Icon from '../Icon';
import { MODEL_VARIANT_EVALKITS, MODEL_VARIANT_SAMPLES } from '../../config/tabbed-content';
import { LABELS } from '../../config/data';
import { TYPE_OPEN_IN_NEW_TAB } from '../../config/icon-types';
import { sendUserInteractionsToTelemetryFor } from '../../utility/analytics.telemetry';
import { EVALUATION_BOARD_CLICK_EVENT, SAMPLE_CLICK_EVENT } from '../../config/analytics.telemetry';
import './style.css';

/**
 * Renders a list of sensor models (samples or Evaluation kits) specific to the selected solution
 * @param {*} props Props passed to this component
 * @returns {React.ReactComponentElement} Sensor Models Component
 */
const SensorModels = props => {
	const classes = ['adi-isp__sensor-models'];
	const { models, solutionId, variant } = props;
	const isEvalKits = variant === MODEL_VARIANT_EVALKITS;
	const modelNameKey = isEvalKits ? 'model' : 'partName';

	/**
	 * Returns a function that makes a telemetry request for 'evaluation_board_click' or 'sample_click' event
	 * @param {object} model Object containing 'model', 'description' and 'inventory' url
	 * @returns {function} Function referencing the passed 'model'
	 */
	const onModelClick = model => () => {
		const eventName = isEvalKits ? EVALUATION_BOARD_CLICK_EVENT : SAMPLE_CLICK_EVENT;
		sendUserInteractionsToTelemetryFor(eventName, model, solutionId);
	};

	return (
		<article className={classes.join(' ')}>
			<header className={`${classes[0]}-header`}>
				<span>{LABELS[`${variant}TblColumn1Label`]}</span>
				<span>{LABELS[`${variant}TblColumn2Label`]}</span>
				<span>{LABELS[`${variant}TblColumn3Label`]}</span>
			</header>

			<ul className={`${classes[0]}-body`}>
				{models.map((model, index) => {
					const modelName = model[modelNameKey];
					const description = model.description;
					const inventory = model.detailedInfoUrl;

					return (
						<li key={`${modelName}-${index}`} className={`${classes[0]}-row`}>
							<span>{modelName}</span>
							<span>{description}</span>
							<span>
								<a
									href={inventory}
									target="_blank"
									rel="noopener noreferrer"
									onClick={onModelClick({
										model: modelName,
										description,
										inventory,
									})}
								>
									<Icon type={TYPE_OPEN_IN_NEW_TAB} />
									<span>{LABELS[`${variant}Button`]}</span>
								</a>
							</span>
						</li>
					);
				})}
			</ul>
		</article>
	);
};

SensorModels.propTypes = {
	models: PropTypes.arrayOf(
		PropTypes.shape({
			model: PropTypes.string,
			partName: PropTypes.string,
			description: PropTypes.string.isRequired,
			detailedInfoUrl: PropTypes.string.isRequired,
		}),
	).isRequired,
	solutionId: PropTypes.string.isRequired,
	variant: PropTypes.oneOf([MODEL_VARIANT_EVALKITS, MODEL_VARIANT_SAMPLES]).isRequired,
};

export default SensorModels;
